import { bootOnce } from '../../bootstrap';
import { useMemo } from 'preact/hooks';
import { useI18n } from '../../bootstrap/i18n';
import { BottomSheet } from '../../ui/sheets/BottomSheet';
import { buildTelegramStartAppLink } from '../../utils/startAppNavigation';

export function OpenInTelegramOverlay(props: {
  desiredPath: string;
  onClose: () => void;
  /** When false, user cannot dismiss by tapping backdrop (used for Telegram gate). */
  dismissable?: boolean;
}) {
  const services = useMemo(() => bootOnce(), []);
  const { t } = useI18n(services.i18n);

  const mainLink = buildTelegramStartAppLink(services.config.config.mainBotUsername, props.desiredPath);

  return (
    <BottomSheet open={true} onClose={props.onClose} dismissOnBackdrop={props.dismissable !== false} ariaLabel={t('outside.overlay_title', 'Continue the fun in Telegram')} centered>
      <div class="tgGateGlow" aria-hidden="true" />
      
      <div class="tgGateContent">
        <div class="tgGateIcon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>

        <div class="tgGateTitle">{t('outside.overlay_title', 'Continue the fun in Telegram')}</div>
        
        <div class="tgGateText">
          {t(
            'outside.overlay_text',
            'To keep chatting and unlock actions, open AICAMS in Telegram. It takes one tap.',
          )}
        </div>

        <div class="tgGateBenefits">
          <div class="tgGateBenefit">
            <span class="tgGateCheck">✓</span>
            {t('outside.overlay_b1', 'Resume from the same place')}
          </div>
          <div class="tgGateBenefit">
            <span class="tgGateCheck">✓</span>
            {t('outside.overlay_b2', 'Chat + credits work correctly')}
          </div>
          <div class="tgGateBenefit">
            <span class="tgGateCheck">✓</span>
            {t('outside.overlay_b3', 'Fast, private, and secure')}
          </div>
        </div>
      </div>

      <div class="tgGateFooter">
        <a class="primaryBtn tgGateCta" href={mainLink}>
          {t('outside.overlay_cta', 'Open in Telegram')}
        </a>
        <div class="tgGateHint">{t('outside.hint', 'Tip: open the bot in Telegram → tap “Open App”.')}</div>
      </div>
    </BottomSheet>
  );
}
